import { render, staticRenderFns } from "./VerificationAlert.vue?vue&type=template&id=9dcdb6e4&"
import script from "./VerificationAlert.vue?vue&type=script&lang=js&"
export * from "./VerificationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports